import { Arrange, Container } from '@loomhq/lens';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { ROLLOUT_VIDEO_PLAYER_END_SCREEN } from 'constants/featureFlag';

import { useFlagIsActivated } from 'hooks/featureFlag';
import { selectCtaEnabled } from 'selectors/shareVideo';
import {
  selectHasEnded,
  selectHasStarted,
  selectShowCta,
} from 'selectors/videoPlayer';

import EmbedActionButtons from './action-buttons';
import CtaButton from './cta-button-rework';
import EmbedTitleAuthor from './embed-title-author';

import styles from './styles.module.less';

const EmbedTopBar = () => {
  const hasStarted = useSelector(selectHasStarted);
  const showCta = useSelector(selectShowCta);
  const ctaEnabled = useSelector(selectCtaEnabled);
  const hasEnded = useSelector(selectHasEnded);

  const newEndScreenFeature = useFlagIsActivated({
    flag: ROLLOUT_VIDEO_PLAYER_END_SCREEN,
    activationValues: ['variant'],
  });

  const showFullBar = !hasStarted || (hasEnded && newEndScreenFeature);

  return (
    <div className={classnames(styles.embedTopSection, 'theme-dark')}>
      <Container
        padding={{ default: 'small', small: 'medium' }}
        position="absolute"
        top={0}
        width="100%"
      >
        <Arrange justifyContent="space-between" gap="small" alignItems="start">
          <Container minWidth={0}>
            {showFullBar && <EmbedTitleAuthor />}
          </Container>
          <Arrange gap="small" minWidth="max-content">
            {ctaEnabled && showCta && <CtaButton />}
            <EmbedActionButtons />
          </Arrange>
        </Arrange>
      </Container>
    </div>
  );
};

export default EmbedTopBar;
